export const MAX_RATING = 10
